import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { environment } from 'src/environments/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GestionCobrosService extends BaseService{
    url = `${ environment.host }/gestion-cobros`;

    async getCobrosPagoFacil( filtros : Record< string, any > ) {
        try {
            await this.updateToken();
            // this.header['filters'] = JSON.stringify(await this.getAdicionalFilters());
            let url = `${this.url}/get-cobros-pf`;
            const resp = await lastValueFrom( this.http.post<any>(`${url}`,{ filtros }, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }
    
    async getCobrosTech( filtros : Record< string, any > ) {
        try {
            await this.updateToken();
            // this.header['filters'] = JSON.stringify(await this.getAdicionalFilters());
            let url = `${this.url}/get-cobros-tech`;
            const resp = await lastValueFrom( this.http.post<any>(`${url}`,{ filtros }, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }
    
    async getUsuariosPF(){
        try {
            await this.updateToken();
            // this.header['filters'] = JSON.stringify(await this.getAdicionalFilters());
            let url = `${this.url}/usuarios-pf`;
            const resp = await lastValueFrom( this.http.get<any>(`${url}`, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async getUsuariosTech(){
        try {
            await this.updateToken();
            // this.header['filters'] = JSON.stringify(await this.getAdicionalFilters());
            let url = `${this.url}/usuarios-tech`;
            const resp = await lastValueFrom( this.http.get<any>(`${url}`, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

}
